import { useCallback, useEffect } from "react";
import { useLocalStorage, useSessionStorage } from "usehooks-ts";
import { WorkspaceService } from "@/services/workspace/workspace.service";

const localStorageKey = "currentWorkspaceId";
const sessionStorageKey = "sessionCurrentWorkspaceId";
const defaultCategoryMaxLevel = 3;

export const useWorkspaces = () => {
  const [currentWorkspaceId, setCurrentWorkspaceId] = useLocalStorage(
    localStorageKey,
    "",
  );
  const [sessionCurrentWorkspaceId, setSessionCurrentWorkspaceId] = useSessionStorage(sessionStorageKey, "");

  const { workspaces, error, isLoading, mutate } = WorkspaceService.getWorkspaces();

  const currentWorkspace = workspaces?.find((w) => w.id === sessionCurrentWorkspaceId);

  const categoryMaxLevel = currentWorkspace?.categoryMaxLevel ?? defaultCategoryMaxLevel;

  // ワークスペースIDを両方のストレージに同期する関数
  const setWorkspaceId = useCallback(
    (workspaceId: string) => {
      setCurrentWorkspaceId(workspaceId);
      setSessionCurrentWorkspaceId(workspaceId);
    },
    [setCurrentWorkspaceId, setSessionCurrentWorkspaceId],
  );

  // sessionStorageが空でlocalStorageに値がある場合、sessionStorageを初期化
  useEffect(() => {
    if (!sessionCurrentWorkspaceId && currentWorkspaceId) {
      setSessionCurrentWorkspaceId(currentWorkspaceId);
    }
  }, [sessionCurrentWorkspaceId, currentWorkspaceId, setSessionCurrentWorkspaceId]);

  // 初回アクセス時にワークスペースがない場合は、デフォルトワークスペースを選択する
  useEffect(() => {
    if (sessionCurrentWorkspaceId || currentWorkspaceId || !workspaces || workspaces.length === 0) return;
    // デフォルトワークスペースはテナント作成時に作成されるため常に0番目
    setWorkspaceId(workspaces[0].id);
  }, [workspaces, setWorkspaceId, sessionCurrentWorkspaceId, currentWorkspaceId]);

  return {
    workspaces,
    currentWorkspace,
    sessionCurrentWorkspaceId,
    currentWorkspaceId,
    categoryMaxLevel,
    error,
    isLoading,
    mutate,
    setWorkspaceId,
  };
};
